import { render, staticRenderFns } from "./CompanyMultiRestaurantTabEmployees.vue?vue&type=template&id=672947e2"
import script from "./CompanyMultiRestaurantTabEmployees.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantTabEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports